import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import moment from 'moment';
import {Platform} from '@angular/cdk/platform';
import {UntypedFormControl, Validators} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {DialogInput, OutputDialogData} from '../../models/dialog-models';

@Component({
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html',
    styleUrls: ['./input-dialog.component.scss']
})
export class InputDialogComponent<T> implements OnInit {

    protected dialogInfo: DialogInput<T>;
    protected inputValue: T;
    protected isIos: boolean;
    protected inputCtrl = new UntypedFormControl();
    protected validationError = new BehaviorSubject('');
    private currentOutputDialogData: OutputDialogData<T> = {
        doSave: false,
        value: (undefined as T)
    };

    constructor(public dialogRef: MatDialogRef<InputDialogComponent<T>>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public platform: Platform) {
        this.isIos = this.platform.IOS;
        this.dialogInfo = data;
        switch (this.dialogInfo.type) {
            case 'time':
                this.inputValue = moment(data.defaultValue).format('HH:mm') as T;
                break;
            case 'number':
                const i = parseFloat(data.defaultValue) as T;
                if (i) {
                    this.inputValue = i;
                } else {
                    this.inputValue = undefined as T;
                }
                if (this.dialogInfo.options?.max !== undefined) {
                    this.inputCtrl.addValidators(Validators.max(this.dialogInfo.options.max as number));
                }
                if (this.dialogInfo.options?.min !== undefined) {
                    this.inputCtrl.addValidators(Validators.min(this.dialogInfo.options.min as number));
                }
                break;
            case 'text':
            default:
                this.dialogInfo.type = 'text';
                this.inputValue = this.dialogInfo.defaultValue;
                break;
        }
    }

    ngOnInit(): void {
    }

    closeDialog(isYes: boolean): void {
        this.currentOutputDialogData.doSave = isYes;
        if (!this.currentOutputDialogData.doSave) {
            this.dialogRef.close(this.currentOutputDialogData);
        }
        if (!this.inputCtrl.valid) {
            return this.validationError.next('MAIN_APP_DIALOG.INPUT_DIALOG.validationError');
        }
        this.currentOutputDialogData.value = this.inputValue;
        this.dialogRef.close(this.currentOutputDialogData);
    }

}
